<template>
  <div style="width: 600px; overflow: hidden">
    <!-- 下一状态 按钮 -->
    <el-dropdown split-button v-loading.fullscreen.lock="fullscreenLoading" @click="NextState" style="margin-left: 10px"
      size="mini" @command="goToState">
      <span :disabled="checkDisabled()">
        {{ $t("message.title.manualNextStatus") }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in statusInfoList" :key="item.id" :statusType="item.statusType" :command="item.id"
          :disabled="getStatusItemPriv(item)">{{ item.name }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 操作 按钮 -->
    <el-dropdown placement="bottom" style="margin-left: 10px">
      <el-button size="mini">
        {{ $t("message.button.actions")
        }}<i class="el-icon-arrow-down el-icon--right" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <!-- 暂停 取消暂停 以及取消等操作 -->
        <project-operate />
        <!-- 收藏，取消收藏，另存为 等操作 -->
        <common-operate />

        <el-dropdown-item v-if="getProjectChange()" @click.native="sendChange"
          :disabled="!projectEcrInfo.createProjectEcr">
          项目变更申请
        </el-dropdown-item>

        <!-- <demo /> -->
      </el-dropdown-menu>
    </el-dropdown>
    <!-- <el-button @click="getPreview">click </el-button> -->
    <slot></slot>
  </div>
</template>

<script>
import axios from "axios";
import { createProjectEcrChangeAPI } from "./api";
import CommonOperate from "./commonOperate.vue";
import ProjectOperate from "./projectOperate.vue";
import { mapGetters } from "vuex";
// import Demo from "./demo.vue";
export default {
  data() {
    return {
      // statusInfoList: []
      fullscreenLoading: false,
    };
  },
  mounted() { },
  components: {
    ProjectOperate,
    CommonOperate,
    // Demo
  },

  methods: {

    checkDisabled() {
      const { isAdministrator, isExecuter, editByStatusType } = this.getPriv;
      console.log({ isAdministrator, isExecuter, editByStatusType });

      // 非 项目经理、负责人 、执行者不可点击
      if (!(isAdministrator || isExecuter)) {
        return true
      }
      // 项目为完成状态不可点击 （statusType === 3 ，4）
      if (!editByStatusType) {
        return true
      }
      return false
    },
    getStatusItemPriv(item) {
      const { isAdministrator, isExecuter } = this.getPriv;
      return !item.hasPriv || !(isAdministrator || isExecuter)
    },

    getChangeEdit() { },

    sendChange() {
      const { id, classId, subClassId: subclassId } = this.$route.query;
      const obj = {
        id,
        classId,
        subclassId,
      };
      createProjectEcrChangeAPI(obj).then((res) => {
        const { code, object, message } = res.data;
        if (code === 200) {
          this.$message.success(message);
          this.setPageStatus(object);
        }
      });
    },
    setPageStatus(obj) {
      const { editProject, createProjectEcr } = obj;
      this.$store.commit("projectWorkflow/SET_PROJCET_ECR", {
        editProject,
        createProjectEcr,
      });
    },
    getProjectChange() {
      const changeRequestId =
        window.sessionStorage.getItem("projectChangeRequest") || 0;
      const { isRoot = 0 } = this.projectStatus.specialProjectVo;
      return !!Number(changeRequestId) && isRoot;
    },

    NextState() {
      const { currectStatus, projectStatusList } = this.projectStatus;
      const [item] = projectStatusList,
        { id = "" } = item;
      if (id === "") {
        return;
      }
      this.updateState(id);
      // const id = 1;
      // this.updateState(id);
      // if (!this.isExecuter || this.nextStateBtnDisable) {
      //   return false;
      // }
      // this.statusInfo.length && this.updateState(this.statusInfo[0].id);
      // this.$emit("reloadPage");
    },
    goToState(id) {
      this.updateState(id);
    },
    updateState(stateId) {
      const { id } = this.$route.query,
        stateVal = {
          projectId: id,
          targetStatusId: stateId,
        };
      axios.post("/ppm/project/changeProjectStatus", stateVal).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: this.$t("message.success.actions"),
            type: "success",
          });
          const { id, classId, subClassId } = this.$route.query;
          const obj = { id, classId, subClassId };
          this.$store.dispatch("projectWorkflow/getWorkFlowStatus", obj);
          // this.getAllStatus();
        }
      });
    },
  },
  created() { },
  computed: {
    ...mapGetters({
      projectStatus: "projectWorkflow/getProjectInfo",
      projectEcrInfo: 'projectWorkflow/getCreateEcrInfo',
      getPriv: "projectWorkflow/getPriv",
    }),

    isRoot() {
      const { isRoot } = this.projectStatus.specialProjectVo;
      return !!isRoot;
    },

    statusInfoList() {
      const { projectStatusList = [] } =
        this.$store.state.projectWorkflow.statusInfo;
      return projectStatusList;
    },
    proExecuters() {
      const { executers } = this.$store.state.projectWorkflow.statusInfo,
        { projectDirectors } = this.$store.state.project;
      const arr = executers.map((i) => i.id);
      return [...arr, ...projectDirectors];
    },
  },

  watch: {
    statusInfoList(val) { },
  },
};
</script>